import React, { useState, useEffect } from 'react';
import { DropdownButton, Dropdown, ButtonGroup} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Bar } from "@nivo/bar";
import ReactWordcloud from 'react-wordcloud';
import '../node_modules/react-vis/dist/style.css';




function App(): JSX.Element {

  const api = 'https://partygrams-pro.herokuapp.com/';
  const [corpus, setCorpus] = useState<string>('Select corpus to analyse');
  const [speaker, setSpeaker] = useState<string | null>('Select speaker');
  const [visualization, setVisualization] = useState<string | null>('Select visualization');
  const [fetchUrl, setFetchUrl] = useState(api);
  const [query, setQuery] = useState<{[k: string]: any}>({});

  let corpora: string[] = ['2020 DNC Debates', 'Star Trek: The Next Generation', 'Critical Role Campaign One'];

  let speakers: {[key:string]: string[]} = {
    '2020 DNC Debates': ['Biden', 'Buttigieg', 'Gabbard', 'Klobuchar', 'Sanders', 'Warren', 'Yang'],
    'Star Trek: The Next Generation': ['Data', 'LaForge', 'Picard', 'Riker'],
    'Critical Role Campaign One': ['Ashley', 'Laura', 'Liam', 'Marisha', 'Matt', 'Orion', 'Sam', 'Taliesin', 'Travis']

  };


  useEffect(() => {
    if (fetchUrl){
      fetch(fetchUrl).then(res => res.json()).then(data => {
        setQuery(data);
      });
    }
  }, [fetchUrl]);


  console.log(query);

  let GraphInput: {text:string, value:number}[] = [];

  for(var key in query){
    var temp = {text:key, value:query[key]};
    GraphInput.push(temp);
  };

  console.log(GraphInput)

  return (
    <div className="App">

      <DropdownButton id="dropdown-basic-button" as={ButtonGroup} title={corpus} onSelect={(c: string | null) => setCorpus(String(c))}>
        {corpora.map((e) => {
          return <Dropdown.Item onClick={() => setFetchUrl(api + e)} eventKey={e}>{e}</Dropdown.Item>
        })}
      </DropdownButton>
      <DropdownButton id="dropdown-basic-button" as={ButtonGroup} title={speaker} onSelect={(s: string | null) => setSpeaker(s)}>
        {(speakers.hasOwnProperty(corpus)) && 
          speakers[corpus].map((e) => {
            return <Dropdown.Item onClick={() => setFetchUrl(api + e)} eventKey={e}>{e}</Dropdown.Item>
          })
        }
      </DropdownButton>
      <DropdownButton id="dropdown-basic-button" as={ButtonGroup} title={visualization} onSelect={(v: string | null) => setVisualization(v)}>
      <Dropdown.Item eventKey='Bar Chart'>Bar Chart</Dropdown.Item>
      <Dropdown.Item eventKey='Word Cloud'>Word Cloud</Dropdown.Item>
      </DropdownButton>

      {visualization === 'Word Cloud'
        ? <ReactWordcloud options={{fontSizes: [30,80], rotations: 0}} words={GraphInput} />
        : <Bar height={800} width={800} data={GraphInput} padding={0.2} keys={["value"]} margin={{ top: 60, right: 80, bottom: 60, left: 80 }} indexBy="text"  />
      }

         
    </div>
  );
}

export default App;
